// helpers.js
// Miscellaneous utility functions used across the app.

// Truncate long text with ellipsis
export function truncate(text, maxLength = 80) {
  if (!text) return "";
  return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
}

// Generate star rating display (e.g., "★★★★☆" for 4.2)
export function starRating(rating) {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return "★".repeat(full) + (half ? "✦" : "") + "☆".repeat(empty);
}

// Format a Firestore Timestamp or JS Date to a readable string
export function formatDate(timestamp) {
  if (!timestamp) return "";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

// Generate a short order ID for display (last 8 chars of Firestore doc ID)
export function shortOrderId(id) {
  if (!id) return "";
  return "#" + id.slice(-8).toUpperCase();
}

// Get badge colour class based on order status
export function statusBadgeClass(status) {
  const map = {
    pending:    "bg-yellow-100 text-yellow-800",
    confirmed:  "bg-blue-100 text-blue-800",
    shipped:    "bg-purple-100 text-purple-800",
    delivered:  "bg-green-100 text-green-800",
    cancelled:  "bg-red-100 text-red-800",
  };
  return map[status?.toLowerCase()] || "bg-gray-100 text-gray-800";
}
